import React, { useEffect } from 'react';
import ContainerWrapper from 'Common/Components/ContainerWrapper';
import Loading from 'Common/Components/Loading';
import { publishErrorUIMsg } from 'Common/notifications';
import { defineMessage } from 'react-intl';
import { AccountErrorResponse } from 'utils/apiClient/services/core/types';
import { useAccount } from '../hooks/account';
import AccountOnboarding from '../components/AccountOnboarding';
import AccountOverview from '../components/AccountOverview';

const AccountScreen = () => {
  const { isLoading, error } = useAccount({ refetchOnWindowFocus: false });
  useEffect(() => {
    if (error) {
      if ((error as AccountErrorResponse).status_code === 404) {
        publishErrorUIMsg(
          defineMessage({
            defaultMessage: 'Could not load account information',
          })
        );
      }
    }
  }, [error]);

  return (
    <ContainerWrapper css="margin: 24px">
      {isLoading && <Loading noText verticallyCentered />}
      <AccountOnboarding />
      <AccountOverview />
    </ContainerWrapper>
  );
};

export default AccountScreen;
